import React from "react";
import Moment from "react-moment";
import { Helmet } from "react-helmet";
import { withRouter, Link } from "react-router-dom";
import { useQuery, useMutation } from "react-apollo-hooks";
import {
  BANNER_DETAIL_QUERY,
  BANNER_DELETE_QUERY,
  BANNER_LIST_QUERY,
} from "./Queries";
import { Panel, PanelHeader, PanelBody } from "../../../Components/Panel/Panel";
import { Button } from "reactstrap";
import { graphqlUri } from "../../../Config/Env";
import { toast } from "react-toastify";

export default withRouter(({ history, match, location }) => {
  const { data: detail, loading } = useQuery(BANNER_DETAIL_QUERY, {
    variables: { id: match.params.id },
  });

  const [bannerDeleteMutation] = useMutation(BANNER_DELETE_QUERY, {
    refetchQueries: () => [
      {
        query: BANNER_LIST_QUERY,
        variables: {
          keyword: "",
          skip: 0,
          first: 15,
        },
      },
    ],
  });
  const onDelete = async (id) => {
    try {
      const {
        data: { AdminBannerDelete },
      } = await bannerDeleteMutation({
        variables: {
          id: id,
        },
      });
      if (AdminBannerDelete) {
        toast.success("처리 되었습니다.");
        history.push(`/banners${location.search}`);
      }
    } catch (e) {
      console.log(e);
      toast.error("에러가 발생했습니다. 다시 시도해 주세요.");
    }
  };

  if (loading === true) {
    return (
      <div className="panel-loader">
        <span className="spinner-small"></span>
      </div>
    );
  } else if (!loading && detail && detail.AdminBannerDetail) {
    const {
      AdminBannerDetail: {
        id,
        commonStatus,
        coverImage,
        title,
        // stack,
        // screen,
        createdAt,
        // updatedAt,
      },
    } = detail;
    const bannerCoverImage =
      coverImage === ""
        ? "/assets/img/user/user-default.jpg"
        : `${graphqlUri}${coverImage}`;
    return (
      <>
        <Helmet>
          <title>배너 관리 | 한밭페이 </title>
        </Helmet>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item ">선물</li>
            <li className="breadcrumb-item active">배너</li>
          </ol>
          <h1 className="page-header">배너</h1>
          <div className="row m-b-15">
            <div className="col-xs-6 text-left">
              <Link to={`/banners${location.search}`} className="btn btn-white">
                목록
              </Link>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <Link
                  className="btn btn-white text-success"
                  to={`/banners/${id}/edit${location.search}`}
                >
                  수정
                </Link>

                <Button
                  type="button"
                  color="white"
                  className="text-red"
                  onClick={() => {
                    onDelete(id);
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <Panel>
                <PanelHeader>상세내용</PanelHeader>
                <PanelBody className="panel-form">
                  <div className="wrapper ">
                    <div className="bg-grey-transparent-5 text-center">
                      <img
                        src={bannerCoverImage}
                        alt="이미지 업로드"
                        className="height-200"
                      />
                    </div>
                    <h3 className="m-t-20 f-w-500">
                      {commonStatus === "S" && (
                        <span className="label label-danger">비공개</span>
                      )}{" "}
                      {commonStatus === "C" && (
                        <span className="label label-primary">공개</span>
                      )}{" "}
                      {title}
                    </h3>
                  </div>
                  <div className="p-15 bg-grey-transparent-5">
                    <div className="info_ul">
                      <ul>
                        <li>
                          <b>작성일 :</b>
                          <Moment format="YYYY-MM-DD HH:mm:ss">
                            {createdAt}
                          </Moment>
                        </li>
                      </ul>
                    </div>
                  </div>
                </PanelBody>
              </Panel>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6 text-left">
              <Link to={`/banners${location.search}`} className="btn btn-white">
                목록
              </Link>
            </div>
            <div className="col-xs-6 text-right">
              <div className="btn-group">
                <Link
                  className="btn btn-white text-success"
                  to={`/banners/${id}/edit${location.search}`}
                >
                  수정
                </Link>

                <Button
                  type="button"
                  color="white"
                  className="text-red"
                  onClick={() => {
                    onDelete(id);
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
});
